import { render, staticRenderFns } from "./mobile_tabs.vue?vue&type=template&id=7a2543d0"
import script from "./mobile_tabs.vue?vue&type=script&lang=js"
export * from "./mobile_tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports